import Config from './config';

export default class Progress {
  // Start the progress indicator for this transfer
  static start(transfer) {
    // Kill any previous running timer
    Progress.stop(transfer);
    Progress.update(transfer);

    // Only resume if the transfer is still uploading
    if (transfer.state === 'started') {
      transfer._progressTimer = setTimeout(() => {
        Progress.start(transfer);
      }, Config.progress.interval);
    }
  }

  // Update the progress indicator
  static update(transfer) {
    // Calculate how much we've sent so far.
    const total = transfer._gauge.total;
    const sent = transfer.files.reduce(
      (count, file) => count + file.bytesSent,
      0
    );
    const percentage =
      transfer.state === 'finished'
        ? 100
        : Math.min(100, Math.round((sent / total) * 100));

    // Calculate time remaining
    const remaining = transfer._gauge.remaining(sent);
    const duration = transfer._gauge.duration;

    // Emit our progress event
    if (!isNaN(percentage)) {
      transfer.progress = {
        duration,
        percentage,
        remaining,
        total,
        sent,
      };

      transfer.emit('progress', transfer.progress);
    }
  }

  // Stop the progress indicator for this transfer
  static stop(transfer) {
    clearTimeout(transfer._progressTimer);
  }
}
